import styled from 'styled-components';
import { Themes } from '@cyberint/dsc';

// Icon always stays in-flow in the nav bar — never moves
export const GlobalSearchWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SearchIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: var(--nav-item-icon-color);

  svg {
    color: var(--nav-item-icon-color);
  }

  &:focus {
    outline: none;
  }
`;

// Popup floats to the right of the icon — just like other nav sub-menus
export const SearchPopup = styled.div.attrs({
  className: Themes.DARK
})`
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  transform: translateY(-50%);
  width: 180px;
  padding: 0;
  z-index: 1500;
  background-color: rgba(43, 68, 72, 0.65);
  backdrop-filter: blur(52px);
  box-shadow: 10px 10px 40px 0 var(--black-800);
  border-radius: 12px;

  & .dsc-searchInput {
    padding: 4px;
  }

  & input,
  & .MuiInputBase-input {
    color: var(--antiFlashWhite1);
    caret-color: var(--mainGreen);

    &::placeholder {
      color: var(--cadetGray);
      opacity: 1;
    }
  }

  & .MuiOutlinedInput-notchedOutline {
    border-color: var(--darkSlateGray3);
  }

  & .MuiInputAdornment-root svg {
    color: var(--cadetGray);
  }
`;
